import React, { Component } from 'react'
import { injectIntl } from 'react-intl'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import { VERSION, PROD_CLIENT_IAB_COLOMBIA } from '../../utils'
import logoPrivate from '../../assets/images/white_logo.gif'
import { Icon, Row, Col } from 'antd'
import './privateFooter.css'
import { getCustomsClients } from "../../utils";

export class PrivateFooter extends Component {

  constructor(props) {
    super(props);
    this.isCustom = getCustomsClients().map(r => r._id).includes(this.props.workclient);
    this.dataCustom = getCustomsClients().filter(r => r._id === this.props.workclient);
  }


  render() {
    const { workclient, intl } = this.props
    return (
      <React.Fragment>
        {this.isCustom && <div className="footer" >
          <div className="down-footer" style={{ color: 'white' }}>
            <Row type="flex" justify="space-around" align="middle">
              <Col xs={16} sm={8} md={4} lg={4} xl={4}>
                <ul>
                  <li><img src={logoPrivate} alt="Bunkey" style={{ width: 160, marginLeft: -5 }} /></li>
                  <li>{intl.formatMessage({ id: "footer-contact" })}<br />ricardo@bunkey.tv</li>
                  <li>{intl.formatMessage({ id: "footer-copyright" })}</li>
                  <li>v{VERSION}</li>
                </ul>
              </Col>
              <Col xs={16} sm={8} md={4} lg={4} xl={4}>
                <img src="/gnbrands/gn-logo-and-brands.png" alt="GN Brands" style={{ width: 160, marginLeft: -5 }} />
              </Col>
              <Col xs={16} sm={8} md={4} lg={4} xl={4} className='rrss'>
                <ul>
                  <li style={{ fontWeight: 'bold' }}>{intl.formatMessage({ id: "footer-social" })}</li>
                  {this.dataCustom[0].footer.map((r, k) => {
                    return r.ico
                      ? r.ico === 'tiktok'
                        ? <li key={k}><img src="/gnbrands/tiktok.svg" alt="tiktok" style={{ width: 12 }} />&nbsp;<a href={r.url} target='new'>{r.label}</a></li>
                        : <li key={k}><Icon type={r.ico} />&nbsp;<a href={r.url} target='new'>{r.label}</a></li>
                      : <li key={k}><a href={r.url} target='new'>{r.label}</a></li>
                  })}
                </ul>
              </Col>
              <Col xs={16} sm={8} md={4} lg={4} xl={4}>
                <ul>
                  <li style={{ fontWeight: 'bold' }}>{intl.formatMessage({ id: "footer-help" })}</li>
                  <li><a href='https://bunkeylatam.com/preguntas-frecuentes' target='new'>{intl.formatMessage({ id: "footer-faq" })}</a></li>
                  <li><a href='https://calendly.com/bunkey/capacitacion' target='new'>{intl.formatMessage({ id: "footer-training" })}</a></li>
                  <li><a href='https://calendly.com/bunkey/demo_bunkey' target='new'>{intl.formatMessage({ id: "footer-demo" })}</a></li>
                  <li>Soporte@bunkey.tv</li>
                </ul>
              </Col>
            </Row>
          </div>
        </div>}
        {!this.isCustom && <div className="footer" >
          <div className="pre-footer">
            <div className="col-sm-4 footer-contact"></div>
            <div className="col-sm-4 footer-corfo-test" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              {workclient === PROD_CLIENT_IAB_COLOMBIA && <img alt="IAB" style={{ width: 77, marginTop: 32 }} src="/images/iab-logo.png" className="IAB" />}
            </div>
            <div className="col-sm-4 footer-linkedin"></div>
          </div>
          <div className="down-footer" style={{ color: 'white' }}>
            <Row type="flex" justify="space-around" align="middle">
              <Col xs={16} sm={8} md={4} lg={4} xl={4}>
                <ul>
                  <li><img src={logoPrivate} alt="Bunkey" style={{ width: 160, marginLeft: -5 }} /></li>
                  <li>{intl.formatMessage({ id: "footer-contact" })}<br />ricardo@bunkey.tv</li>
                  <li>{intl.formatMessage({ id: "footer-copyright" })}</li>
                  <li>v{VERSION}</li>
                </ul>
              </Col>
              <Col xs={16} sm={8} md={4} lg={4} xl={4}>
                <ul>
                  <li style={{ fontWeight: 'bold' }}>{intl.formatMessage({ id: "footer-res" })}</li>
                  <li><a href='https://bunkeylatam.com/' target='new'>{intl.formatMessage({ id: "footer-home" })}</a></li>
                  <li><a href='https://bunkeylatam.com/blog/' target='new'>{intl.formatMessage({ id: "footer-blogs" })}</a></li>
                  <li><a href='https://bunkeylatam.com/descubrenos/' target='new'>{intl.formatMessage({ id: "footer-discover" })}</a></li>
                  <li><a href='https://bunkeylatam.com/preguntas-frecuentes' target='new'>{intl.formatMessage({ id: "footer-faq" })}</a></li>
                </ul>
              </Col>
              <Col xs={16} sm={8} md={4} lg={4} xl={4} className='rrss'>
                <ul>
                  <li style={{ fontWeight: 'bold' }}>{intl.formatMessage({ id: "footer-social" })}</li>
                  <li><Icon type="instagram" />&nbsp;<a href='https://www.instagram.com/bunkey_dam/' target='new'>Instagram</a></li>
                  <li><Icon type="youtube" />&nbsp;<a href='https://www.youtube.com/channel/UCUeN-p0BJfYPLn986C0s-2A' target='new'>YouTube</a></li>
                  <li><Icon type="linkedin" />&nbsp;<a href='https://www.linkedin.com/company/bunkey/' target='new'>LinkedIn</a></li>
                  <li><Icon type="facebook" />&nbsp;<a href='https://www.facebook.com/Bunkey.tv' target='new'>Facebook</a></li>
                </ul>
              </Col>
              <Col xs={16} sm={8} md={4} lg={4} xl={4}>
                <ul>
                  <li style={{ fontWeight: 'bold' }}>{intl.formatMessage({ id: "footer-help" })}</li>
                  <li><a href='https://bunkeylatam.com/preguntas-frecuentes' target='new'>{intl.formatMessage({ id: "footer-faq" })}</a></li>
                  <li><a href='https://calendly.com/bunkey/capacitacion' target='new'>{intl.formatMessage({ id: "footer-training" })}</a></li>
                  <li><a href='https://calendly.com/bunkey/demo_bunkey' target='new'>{intl.formatMessage({ id: "footer-demo" })}</a></li>
                  <li>Soporte@bunkey.tv</li>
                </ul>
              </Col>
            </Row>
          </div>
        </div>
        }
      </React.Fragment>
    )
  }
}

const mapStateToProps = state => {
  return {
    workclient: state.client.workclient
  }
}

const mapDispatchToProps = {}

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(PrivateFooter)))
